module.exports = __webpack_public_path__ + "static/img/szafa_dso_45.a671e48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_dso_45.svg
// module id = isdj
// module chunks = 1